import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import { useLocation } from "wouter";

interface AuthState {
  loggedIn: boolean | null;
  login: () => void;
  logout: () => Promise<void>;
}

const AuthContext = createContext<AuthState>({
  loggedIn: null,
  login: () => {},
  logout: async () => {},
});

const BASE = import.meta.env.BASE_URL?.replace(/\/$/, "") ?? "";

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [loggedIn, setLoggedIn] = useState<boolean | null>(null);
  const [, navigate] = useLocation();

  useEffect(() => {
    fetch(`${BASE}/api/auth/me`, { credentials: "include" })
      .then((r) => r.json())
      .then((data: { loggedIn: boolean }) => {
        setLoggedIn(data.loggedIn);
      })
      .catch(() => {
        setLoggedIn(false);
      });
  }, []);

  const login = useCallback(() => {
    setLoggedIn(true);
    navigate("/");
  }, [navigate]);

  const logout = useCallback(async () => {
    try {
      await fetch(`${BASE}/api/auth/logout`, {
        method: "POST",
        credentials: "include",
      });
    } catch {
    }
    setLoggedIn(false);
    navigate("/login");
  }, [navigate]);

  return (
    <AuthContext.Provider value={{ loggedIn, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth(): AuthState {
  return useContext(AuthContext);
}
